"use strict";
import BtnBase from './btnbase';
import Browser from './../util/browser';

class BtnHamburger extends BtnBase{
	constructor($con){
		super($con);
	}
	
	init(){
		this.$con.empty();
		let h = '';
		h += '<span class="l1"></span>';
		h += '<span class="l2"></span>';
		h += '<span class="l3"></span>';
		this.$con.append(h);
	}
	
	responsiveHandler(){
		super.responsiveHandler();
		this.clear();
	}
	
	clear(){
		this.$con.find('.l1').velocity('stop').removeAttr('style');
		this.$con.find('.l2').velocity('stop').removeAttr('style');
		this.$con.find('.l3').velocity('stop').removeAttr('style');
	}
	
	over(){
		super.over();
		if(Browser.isiPad) return;
		
		if( this.$con.hasClass('close') ){
			
		} else {
			this.$con.find('.l1').velocity('stop')
				.velocity({width:12},{duration:80})
				.velocity({width:22},{duration:160});
			this.$con.find('.l2').velocity('stop')
				.velocity({width:12},{duration:80,delay:80})
				.velocity({width:22},{duration:160});
			this.$con.find('.l3').velocity('stop')
				.velocity({width:8},{duration:80,delay:160})
				.velocity({width:22},{duration:160});			
		}
		
	}
	
	out(){
		super.out();
		this.clear();
	}
	
	open(){
		this.clear();
		this.$con.addClass('close');
	}
	
	close(){
		this.$con.removeClass('close');		
	}
}

export default BtnHamburger;


// WEBPACK FOOTER //
// ./js/btn/btnhumberger.js